// Live now (instant calls) is /live until GrowthMentor Live takes that
// address (the exo-live flag); then it sits under Mentors.
export const LIVE_NOW_PATH = '/live'
export const LIVE_NOW_UNDER_MENTORS = '/mentors/live-now'

export const liveNowPath = (flags?: { exoLiveEnabled?: boolean } | null) =>
  flags?.exoLiveEnabled ? LIVE_NOW_UNDER_MENTORS : LIVE_NOW_PATH
